module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/accountmaster/loan-sanction-grid/loan-sanction-grid.component.css
// module id = ./src/app/accountmaster/loan-sanction-grid/loan-sanction-grid.component.css
// module chunks = main